import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../App.css"
// Toast container component (render this once in your app)
export default function Toastify() {
  return (
    <ToastContainer
      // position="top-center"
      className="custom-toast-container"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
}

// Helper function to show toasts
export const showToast = (type, message, error = null) => {
  let fullMessage = message;

  if (error) {
    const errorMsg =
      typeof error === "string"
        ? error
        : error?.message || JSON.stringify(error);

    fullMessage = `${message} (${errorMsg})`;
  }

  switch (type) {
    case 'success':
      toast.success(fullMessage);
      break;
    case 'error':
      toast.error(fullMessage);
      break;
    case 'warning':
      toast.warning(fullMessage);
      break;
    case 'info':
      toast.info(fullMessage);
      break;
    default:
      toast(fullMessage);
  }
};